import React, { useEffect, useState, useRef } from 'react';
import { getRouterUrl, Constants, refreshCookie, refreshSession, getSessionSupportUrl, getEnv, getCorrelationId } from '../utils/Utils';
import { configMap } from '../types';
import { useCIAMAuth } from '../hooks/useCIAMAuth';
//@ts-ignore
import MicroAppLoader from '@usb-ui-tools/micro-app-loader';

interface Props {
    onAuthSuccess: (data: any) => void;
    onAuthFailure: (data: any) => void;
}

export const ChallengeModuleLoader = (props: Props) => {
    const ref = useRef(null)
    const ciamAuth = useCIAMAuth();
    const config = configMap[getEnv(ciamAuth?.config)];
    const challengeConfigSettings = {
        transmitConfigs: {
            URL: `${config.TRANSMIT_CONFIG_URL}`,
            APP_ID: 'ciam_mps_web',
            policyIds: {
                POLICY: 'in-session-challenge'
            },
            policyParams: {
                appId: Constants.AUTH.APPLICATION_ID,
                tenantId: Constants.TENANT.ID,
                channelId: Constants.TENANT.CHANNEL,
                appVersion: Constants.AUTH.LOGIN_APP_VERSION,
                applicationId: Constants.AUTH.APPLICATION_ID,
                useCase: 'login',
                XProfileDataRequested: Constants.PROFILE.X_DATA_REQUESTED,
                correlationId: getCorrelationId(),
                routingKey: `${config.ROUTING_KEY}`,
                targetApp: `${ciamAuth.config.appId}`,
            }
        },
        header: {
            'App-ID': Constants.AUTH.APPLICATION_ID,
            'Tenant-ID': Constants.TENANT.ID,
            'Channel-ID': Constants.TENANT.CHANNEL,
            'App-Version': Constants.AUTH.LOGIN_APP_VERSION,
            AK: `${config.HEADER_AK}`,
        },
    }

    const onAuthSuccess = (e: any) => {
        props.onAuthSuccess(e);
    }

    const onAuthFailure = (e: any) => {
        props.onAuthFailure(e);
    }

    const challengeModuleProps = {
        userName: ciamAuth.ciamSession?.ciamUser?.sub,
        configSettings: challengeConfigSettings,
        onTransmitAuthorizationFailure:onAuthFailure,
        onTransmitAuthorizationSuccess:onAuthSuccess,
        onTransmitAuthorizationAnonSuccess:onAuthSuccess,
        onTransmitAuthorizationAnonFailure:onAuthFailure,
        configApiHeaders:challengeConfigSettings.header,
        isReportingEnabled: false
    };

    return <MicroAppLoader
                    elementRef={useRef(null)}
                    id="auth-challenge"
                    manifestPath={config.MANIFEST_LOGOUT_PATH}
					isDomainPrefixedToManifestPath={false}
                    namespace="USBAuthChallenge"
                    appProps={challengeModuleProps}
            />
}